export const FileAPIMessages = {
  FILE_SIZE_GREATER_THAN_100000_BYTES: 'File size greater than 1 MB',
};

export const TERMS_OF_USE_AND_PRIVACY_POLICY_URL =
  'https://confcdnnode2.azureedge.net/pdf/%E6%9C%8D%E5%8B%99%E6%A2%9D%E6%AC%BE%E5%8F%8A%E9%9A%B1%E7%A7%81%E6%AC%8A%E6%94%BF%E7%AD%96.pdf';
